exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.stats-pending .timeline-circle {\n  background-color: #20a8d8;\n}\n.stats-unmatched .timeline-circle {\n  background-color: #f86c6b;\n}\n.stats-accepted .timeline-circle {\n  background-color: #4dbd74;\n}\n.stats-verified .timeline-circle {\n  background-color: orange;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f8445ba0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/reports/formsInsights.vue
// module id = 1256
// module chunks = 2